import React from 'react';

const KnotSide = ({ side }) => (
  <img
    src="/assets/inerva-knot.png"
    alt=""
    aria-hidden="true"
    className={`absolute top-1/2 -translate-y-1/2 w-48 h-auto opacity-10 pointer-events-none hidden lg:block
      ${side === 'left' ? 'left-0 -translate-x-1/2' : 'right-0 translate-x-1/2'}`}
  />
);

const pricingOptions = [
  {
    name: 'Sesión individual',
    price: 55,
    perSession: 55,
    sessions: 1,
    savings: null,
    features: ['Sesión de 50-60 minutos', 'Modalidad online', 'Horario flexible'],
    popular: false,
  },
  {
    name: 'Bono 3 sesiones',
    price: 149,
    perSession: 49.67,
    sessions: 3,
    savings: 16,
    features: ['3 sesiones de 50-60 min', 'Validez 2 meses', 'Horario flexible'],
    popular: false,
  },
  {
    name: 'Bono 5 sesiones',
    price: 220,
    perSession: 44,
    sessions: 5,
    savings: 55,
    features: ['5 sesiones de 50-60 min', 'Validez 4 meses', 'Horario flexible'],
    popular: true,
  },
  {
    name: 'Bono 7 sesiones',
    price: 289,
    perSession: 41.29,
    sessions: 7,
    savings: 96,
    features: ['7 sesiones de 50-60 min', 'Validez 5 meses', 'Horario flexible'],
    popular: false,
  },
];

export default function Pricing({ onContactClick }) {
  return (
    <section id="tarifas" className="section-padding bg-cream relative overflow-hidden">
      <KnotSide side="left" />
      <KnotSide side="right" />
      <div className="container-narrow relative">
        <div className="text-center mb-12">
          <h2 className="mb-4">Tarifas</h2>
          <p className="text-[var(--color-inerva-text-light)] max-w-2xl mx-auto">
            Elige la opción que mejor se adapte a tu proceso terapéutico.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {pricingOptions.map((option, i) => (
            <div
              key={i}
              className={`relative bg-white rounded-[var(--radius-xl)] p-6 border ${
                option.popular
                  ? 'border-[var(--color-inerva-forest)] shadow-lg'
                  : 'border-[rgba(61,79,61,0.08)]'
              }`}
            >
              {option.popular && (
                <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[var(--color-inerva-forest)] text-white text-xs font-medium px-3 py-1 rounded-full">
                  Más popular
                </span>
              )}

              <h3 className="text-lg font-serif text-[var(--color-inerva-forest)] mb-2">{option.name}</h3>

              <div className="mb-4">
                <span className="text-4xl font-serif text-[var(--color-inerva-forest)]">{option.price}€</span>
                {option.sessions > 1 && (
                  <span className="text-sm text-[var(--color-inerva-text-light)] ml-2">
                    ({Math.round(option.perSession)}€/sesión)
                  </span>
                )}
              </div>

              {option.savings && (
                <div className="inline-block bg-[var(--color-inerva-mint)] text-[var(--color-inerva-forest)] text-xs font-medium px-2 py-1 rounded-full mb-4">
                  Ahorras {option.savings}€
                </div>
              )}

              <ul className="space-y-2 mb-6">
                {option.features.map((feature, j) => (
                  <li key={j} className="flex items-start gap-2 text-[var(--color-inerva-text-light)] text-sm">
                    <svg className="w-4 h-4 text-[var(--color-inerva-forest)] mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    {feature}
                  </li>
                ))}
              </ul>

              <button
                onClick={onContactClick}
                className={`w-full py-2.5 rounded-lg font-medium transition-colors ${
                  option.popular
                    ? 'bg-[var(--color-inerva-forest)] text-white hover:bg-[var(--color-inerva-forest)]/90'
                    : 'bg-[var(--color-inerva-mint)] text-[var(--color-inerva-forest)] hover:bg-[var(--color-inerva-mint)]/80'
                }`}
              >
                Reservar
              </button>
            </div>
          ))}
        </div>

        <p className="text-center text-[var(--color-inerva-text-light)] text-sm mt-8">
          Todas las sesiones son online por videollamada. Métodos de pago: transferencia o Bizum.
        </p>
      </div>
    </section>
  );
}
